// extracted by mini-css-extract-plugin
export default {"heading":"ProfileSubVendors_heading__TI2RG"};